import Header from "./components/header/Header"
import Benefit from "./components/benefit/Benefit";
import Content from "./components/Content/Content";
import Usage from "./components/Usage/Usage";
import QA from "./components/QA/QA";
import { useState, useEffect } from "react";
import useScrollSnap from "./useScrollSnap";
import useScreenSize from './useScreenSize';
import "./App.css";
import React from "react";
const App = () => {
  const containerRef = React.createRef();
  const [ss, setSS] = useState(true);
  const screenSize = useScreenSize();
  const [bind, unbind] = useScrollSnap(
    containerRef,
    { snapDestinationY: "100%" }
  );


  // useEffect(() => {
  //   console.log({ screenSize });
  //   if (screenSize.width > 768) {
  //     setSS(true)
  //     console.log("true");
  //   }
  //   else {
  //     setSS(false)
  //     console.log("false");
  //   }
  // }, [screenSize])

  return (ss === true ?
    <div id="container" ref={screenSize.width > 768 ? containerRef : null}>
      <div className="page">
        <Header />
      </div>
      <div className="page ">
        <Benefit />
      </div>
      <div className="page ">
        <Content />
      </div>
      <div className="page ">
        <Usage />
      </div>
      <div className="page ">
        <QA />
      </div>
    </div>
    : <div id="container" >
      <div className="page">
        <Header />
      </div>
      <div className="page ">
        <Benefit />
      </div>
      <div className="page ">
        <Content />
      </div>
      <div className="page ">
        <Usage />
      </div>
      <div className="page ">
        <QA />
      </div>
    </div>);
};


export default App;
